import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=68ed2168&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"
import style0 from "./MemberForm.vue?vue&type=style&index=0&id=68ed2168&prod&scoped=true&lang=css"
import style1 from "./MemberForm.vue?vue&type=style&index=1&id=68ed2168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed2168",
  null
  
)

export default component.exports